<template>
  <v-container
    v-if="answer"
    class="pt-0"
  >
    <v-row>
      <v-col cols="12" xs="12" sm="6" md="5">
        <div class="text-body-1 font-weight-bold text-teal-darken-3">
          {{ `${question}:` }}
        </div>
      </v-col>

      <v-col cols="12" xs="12" sm="6" md="7">
        <div class="text-body-1">
          {{ answer && answer !== '0' ? answer : $t('mission-planning.info.informative-answer.message.zero-item') }}
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>

const props = defineProps({
  question: {
    type: String,
    required: true
  },
  answer: {
    type: String,
    required: false
  },
});
</script>